import React, { useState, useEffect, useMemo } from 'react';
import Select from "react-select";
import { useTranslation } from "react-i18next";
import DataTable from 'react-data-table-component';
import axios from 'axios';
import moment from 'moment';
import bag from "../../Assets/Images/finance/bag.jpg";

import CurrencyFormat from 'react-currency-format';
import { ToastContainer, toast } from 'react-toastify';
import { useParams } from "react-router-dom";
import { Row, Col, Button } from 'reactstrap';
import CompLoaderBtn from '../Common/CompLoaderBtn';
import CompLoaderDt from '../Common/CompLoaderDt';

function CompDtCrmAccount({ onChange, accountId }) {
    const { t } = useTranslation();
    const [componentId] = useState('compDtCashDesk');
    const [data, setData] = useState(null);
    const params = useParams();
    let crmId = params.crmId;
    const [pageNumber, setPageNumber] = useState(0);
    const [pageSize, setPageSize] = useState(5);
    const [sort, setSort] = useState('createDate,ASC');
    const [paginationRowsPerPageOptions] = useState([1, 5, 10, 25, 50, 100]);
    const [totalRows, setTotalRows] = useState(0);

    React.useMemo(() => {
        if (sessionStorage.getItem("currentSession") !== null && sessionStorage.getItem("currentSession")?.bearerToken !== '') {
            if (crmId && crmId) {
                let currentSession = sessionStorage.getItem("currentSession");
                axios.defaults.headers.common["X-User-Language"] = t('language')?.toUpperCase();
                axios.defaults.headers.common["Authorization"] = currentSession !== null ? JSON.parse(currentSession)?.bearerToken : null;
                let ApiGateway = process.env.REACT_APP_API_URL;
                axios.get(ApiGateway + '/finance/account/crm/' + crmId + '/find-and-list?pageNumber=' + pageNumber + '&pageSize=' + pageSize + '&sort=' + sort)
                    .then(response => {
                        if (response.data?.isSucceed === true) {
                            setData(response.data?.payload);
                        }

                    })
                    .catch(error => {
                        console.error(error);
                    });
            }
        }
    }, [t, crmId, pageNumber, pageSize, sort]);

    const [apiCalled, setApiCalled] = useState(false);
    const [apiCalledBy, setApiCalledBy] = useState('');
    const getAccountStatement = accountId => {
        setApiCalledBy('accountStatement');
        setApiCalled(true);
        if ((sessionStorage.getItem("currentSession") !== null && sessionStorage.getItem("currentSession")?.bearerToken !== '')) {
            const timeout = setTimeout(() => {
                onChange({ key: Math.random(), accountId: accountId });
                setApiCalled(false);
            }, 500);
        }
    };

    const [deleteModal, setDeleteModal] = useState(false);
    const [recordId, setRecordId] = useState(false);

    const onGoToItemDetails = props => {
        //history.push('/product/' + props);
        //dispatch(mpMyCashDeskListApi(props));
    };

    const onBtnDeleteItem = props => {
        let message = 'Prohibited action!';
        toast.error(message, { autoClose: 1000 });
        console.log(props);
        setRecordId(props);
        //setDeleteModal(true);
    };

    const handleDeleteTask = () => {
        if (recordId) {
            //dispatch(mpMyCashDeskDeleteByIdApi({ cashDeskId: recordId }));
            //setDeleteModal(false);
            //dispatch(mpMyCashDeskListApi(pageNumber, pageSize, sort));
            //dispatch(mpMyCashDeskListApi(pageNumber, pageSize, sort));
        }
    };


    useEffect(() => {
        //dispatch(mpMyCashDeskListApi(pageNumber, pageSize, sort));
    }, []);


    const handlePageChange = page => {
        setPageNumber(page - 1);
        //dispatch(mpMyCashDeskListApi(page - 1, pageSize, sort));
    }

    const handlePerRowsChange = async (newPerPage, page) => {
        setPageSize(newPerPage);
        //dispatch(mpMyCashDeskListApi(0, newPerPage, sort));
    }

    const columns = [
        {
            name: <span className='font-weight-bold fs-13'>{t('components.crm.crm-account-statement.comp-dt-crm-account.dt.th.account-holder-type')}</span>,
            selector: row =>
                <div className="d-flex align-items-center mt-2">
                    <div className="flex-shrink-0 mb-2">
                        <img src={bag} width={28} height={28} alt="" className="avatar-xs rounded-circle" />
                    </div>
                    <div className="flex-grow-1 ms-2">
                        <h6 className="mb-1">{/*<Link to={'/cash-desk/' + row.id + '/details'} className="text-body">{row.name}</Link>*/}{row?.accountHolderType?.label}</h6>
                        <p className="text-muted mb-2">{row?.currency?.currency?.label}</p>
                    </div>
                    <div className="flex-shrink-0">
                    </div>
                </div>
            ,
            sortable: false,
            maxWidth: "220px"
        },
        {
            name: <span className='font-weight-bold fs-13'>{t('components.crm.crm-account-statement.comp-dt-crm-account.dt.th.account-holder-name')}</span>,
            selector: row => row?.accountHolderName,
            sortable: false,
            maxWidth: "300px"
        },
        {
            name: <span className='font-weight-bold fs-13'>{t('components.crm.crm-account-statement.comp-dt-crm-account.dt.th.debit')}</span>,
            selector: row => <><span>{row?.currency?.symbol + ' '}</span><CurrencyFormat value={row?.debit} displayType={'text'} thousandSeparator={true} /></>,
            sortable: false,
            maxWidth: "60px"
        },
        {
            name: <span className='font-weight-bold fs-13'>{t('components.crm.crm-account-statement.comp-dt-crm-account.dt.th.credit')}</span>,
            selector: row => <><span>{row?.currency?.symbol + ' '}</span><CurrencyFormat value={row?.credit} displayType={'text'} thousandSeparator={true} /></>,
            sortable: false,
            maxWidth: "60px"
        },
        {
            name: <span className='font-weight-bold fs-13'>{t('components.crm.crm-account-statement.comp-dt-crm-account.dt.th.balance')}</span>,
            selector: row => <><span>{row?.currency?.symbol + ' '}</span><CurrencyFormat value={row?.balance} displayType={'text'} thousandSeparator={true} /></>,
            sortable: false,
            maxWidth: "60px"
        },
        {
            name: <span className='font-weight-bold fs-13'>{t('components.crm.crm-account-statement.comp-dt-crm-account.dt.th.creation-date')}</span>,
            selector: row => row?.creationDate != null ? moment(row?.creationDate).format('DD.MM.YYYY HH:mm') : '-',
            sortable: false,
            maxWidth: "185px"
        },
        {
            name: <span className='font-weight-bold fs-13'>{t('components.crm.crm-account-statement.comp-dt-crm-account.dt.th.actions')}</span>,
            selector: row =>
                <>
                    <Button disabled={false} onClick={e => getAccountStatement(row?.id)} className={apiCalled === true && apiCalledBy === 'accountStatement' ? 'btn btn-dark border-0 border w-100 disabled' : 'btn btn-dark border-0 border w-100'}>
                        <div className={apiCalled === true ? '' : 'd-none'}>
                            <CompLoaderBtn />
                        </div>
                        <>
                            {true ? <span className={!(apiCalled === true && apiCalledBy === 'accountStatement') ? '' : 'd-none'}>{t('components.crm.crm-account-statement.comp-dt-crm-account.dt.th.actions.td.button.get')}</span>
                                : <span className={!(apiCalled === true && apiCalledBy === 'accountStatement') ? '' : 'd-none'}>{t('components.crm.crm-account-statement.comp-dt-crm-account.dt.th.actions.td.button.get')}</span>}
                        </>
                    </Button>
                </>,
            sortable: false,
            maxWidth: "135px"
        },
    ];

    const [pending, setPending] = useState(true);
    const [rows, setRows] = useState([]);
    useEffect(() => {
        const timeout = setTimeout(() => {
            setRows(data?.content);
            setPending(false);
            setTotalRows(data?.page?.totalElements);
        }, 0);
        return () => clearTimeout(timeout);
    }, [data]);

    return (
        <React.Fragment>
            <ToastContainer />
            {data ? ((
                <DataTable
                    id={componentId}
                    columns={columns}
                    data={rows}
                    pagination={true}
                    paginationServer
                    onPageChange={page => setPageNumber(page)}
                    paginationPerPage={pageSize}
                    paginationTotalRows={totalRows}
                    onChangePage={handlePageChange}
                    onChangeRowsPerPage={handlePerRowsChange}
                    progressPending={pending}
                    noDataComponent={t('data-table.label.no-data')}
                    paginationRowsPerPageOptions={paginationRowsPerPageOptions}
                    paginationComponentOptions={{
                        rowsPerPageText: t('data-table.label.rows-per-page'),
                        rangeSeparatorText: t('data-table.label.out-of'),
                    }}
                />
            )) : (
                <Row>
                    <Col className={"col-md-12 text-center"}>
                        <CompLoaderDt />
                    </Col>
                </Row>
            )}
        </React.Fragment>
    );
}
export default CompDtCrmAccount;